import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "../../helpers/Endpoints/endpoints";

//followUps

export const createFollowUpByType = createAsyncThunk(
  "enquiry/fetchEnquiryFollowUpCreate",
  async (formData:FormData, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT?.FOLLOW_UP?.CREATE}`,
        formData
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to create the follow Up"
      );
    }
  }
);

export const fetchFollowUpsByType = createAsyncThunk(
  "enquiry/fetchFollowUpsByTypeId",
  async (
    {
      source_entity_type,
      source_entity_id,
      source_category,
    }: {
      source_entity_type: string;
      source_entity_id: string;
      source_category?: string;
    },
    { rejectWithValue }
  ) => {
    try {

      const response = await Axios.get(
        API_ENDPOINT?.FOLLOW_UP?.DETAIL,
        {
          params: {
            source_entity_type,
            source_entity_id,
            ...(source_category && { source_category }),
          },
        }
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Follow Up"
      );
    }
  }
);
